import { Map, Placemark, YMaps } from "@pbe/react-yandex-maps";

import i18next from "i18next";
import { Content, Info, MapLocation, Subtitles, Title, Wrapper, WrapperInner } from "./style";

export const ContactsComponent = () => {
  const { t } = i18next;

  return (
    <Wrapper>
      <Title>{t("contact_information")}</Title>
      <WrapperInner>
        <Info>
          <div>
            <Subtitles>{t("phone_number")}</Subtitles>
            <Content>
              <a href="tel:+998885979009">+998885979009</a>
            </Content>
            <Content>
              <a href="tel:+998772979009">+998772979009</a>
            </Content>
          </div>

          <div>
            <Subtitles>{t("email")}</Subtitles>
            <Content>
              <a href="mailto:ticket@aviabozor.uz">ticket@aviabozor.uz</a>
            </Content>
          </div>

          <div>
            <Subtitles>{t("workH")}</Subtitles>
            <Content>{t("working_hours")}</Content>
          </div>
        </Info>

        <MapLocation>
          <Subtitles>{t("location")}</Subtitles>
          <Content style={{ marginBottom: "20px" }}>
            100015, Узбекистан, город Ташкент, улица Хонзодабегим, 9/1, 5-й этаж
          </Content>

          <YMaps
            preload={true}
            query={{
              lang: "ru_RU",
            }}
          >
            <Map
              width={"350px"}
              height={"350px"}
              defaultState={{
                center: [41.292454, 69.28315],
                zoom: 15,
                controls: ["zoomControl", "fullscreenControl"],
              }}
              modules={["control.ZoomControl", "control.FullscreenControl"]}
            >
              <Placemark
                defaultGeometry={[41.292454, 69.28315]}
                properties={{
                  balloonContentBody: "ООО «BILETONLINE», г. Ташкент, ул. Хонзодабегим, 9/1",
                }}
              />
            </Map>
          </YMaps>
        </MapLocation>
      </WrapperInner>
    </Wrapper>
  );
};
